// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalItem_backdrop__nwihE","container":"ModalItem_container__y2o4i","chatContainer":"ModalItem_chatContainer__q9JJb","chat":"ModalItem_chat__D5gqI"};